import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// "ResizeObserver loop completed with undelivered notifications" is a benign browser
// notice (fired by resize-driven UI like the combobox/select popovers), not a real
// error. CRA's dev overlay still surfaces it as a runtime error. Swallowing the error
// event isn't enough (the overlay's listener is registered first), so we stop it at the
// source: defer each ResizeObserver callback to the next animation frame, which prevents
// the observer from re-entering within the same frame — the condition that triggers the
// notice. Zero user-facing impact; layout still settles on the following frame.
const NativeResizeObserver = window.ResizeObserver;
if (NativeResizeObserver) {
  window.ResizeObserver = class extends NativeResizeObserver {
    constructor(callback: ResizeObserverCallback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => callback(entries, observer));
      });
    }
  };
}
// Belt-and-suspenders: also swallow the message if it still slips through.
window.addEventListener("error", (e) => {
  if (e.message && e.message.startsWith("ResizeObserver loop")) {
    e.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
